import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    ma_ho_gia_dinh: null,
    ho_va_ten: null,
    quan_he_voi_chu_ho: null,
    gioi_tinh: "2",
    ngay_sinh: null,
    cmt: null,
    ngay_cap: null,
    noi_cap: null,
    ma_bhyt: null,
    ho_khau_thuong_tru: null,
    xa_phuong_thuong_tru: null,
    quan_huyen_thuong_tru: null,
    tinh_thuong_tru: null,
    noi_o_hien_tai: null,
    xa_phuong_hien_tai: null,
    quan_huyen_hien_tai: null,
    tinh_hien_tai: null,
    dien_thoai_co_dinh: null,
    dien_thoai_di_dong: null,
    email: null,
    ho_ten_bo: null,
    dien_thoai_co_dinh_bo: null,
    dien_thoai_di_dong_bo: null,
    ho_ten_me: null,
    dien_thoai_co_dinh_me: null,
    dien_thoai_di_dong_me: null,
    ho_ten_nguoi_cham_soc: null,
    moi_quan_he: null,
    dien_thoai_co_dinh_nguoi_cham_soc: null,
    dien_thoai_di_dong_nguoi_cham_soc: null,
    ngay_thu_thap: null,
    can_nang: null,
    chieu_cao: null,
    vong_bung: null,
    huyet_ap: null,
    nhom_mau: null,
    tang_huyet_ap: null,
    dai_thao_duong: null,
    nguoi_cung_cap_thong_tin: null,
    nguoi_tiep_nhan_phieu: null
};

// validation form
model.validForm = {
    ma_ho_gia_dinh: [],
    ho_va_ten: [ValidService.requiredChange],
    quan_he_voi_chu_ho: [],
    gioi_tinh: [],
    ngay_sinh: [ValidService.requiredChange],
    cmt: [],
    ngay_cap: [],
    noi_cap: [],
    ma_bhyt: [],
    ho_khau_thuong_tru: [ValidService.requiredChange],
    xa_phuong_thuong_tru: [ValidService.requiredChange],
    quan_huyen_thuong_tru: [ValidService.requiredChange],
    tinh_thuong_tru: [ValidService.requiredChange],
    noi_o_hien_tai: [ValidService.requiredChange],
    xa_phuong_hien_tai: [ValidService.requiredChange],
    quan_huyen_hien_tai: [ValidService.requiredChange],
    tinh_hien_tai: [ValidService.requiredChange],
    dien_thoai_co_dinh: [ValidService.checkPhone],
    dien_thoai_di_dong: [ValidService.checkPhone],
    email: [ValidService.checkEmail],
    ho_ten_bo: [],
    dien_thoai_co_dinh_bo: [ValidService.checkPhone],
    dien_thoai_di_dong_bo: [ValidService.checkPhone],
    ho_ten_me: [],
    dien_thoai_co_dinh_me: [ValidService.checkPhone],
    dien_thoai_di_dong_me: [ValidService.checkPhone],
    ho_ten_nguoi_cham_soc: [],
    moi_quan_he: [],
    dien_thoai_co_dinh_nguoi_cham_soc: [ValidService.checkPhone],
    dien_thoai_di_dong_nguoi_cham_soc: [ValidService.checkPhone],
    ngay_thu_thap: [],
    can_nang: [],
    chieu_cao: [],
    vong_bung: [],
    huyet_ap: [ValidService.checkBloodPressure],
    nhom_mau: [],
    tang_huyet_ap: [],
    dai_thao_duong: [],
    nguoi_cung_cap_thong_tin: [],
    nguoi_tiep_nhan_phieu: []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["ngay_thu_thap", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
    }
};

export default model;